import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-c-dark">
      {/* Header */}
      <div className="bg-c-dark pt-20 pb-16">
        <div className="max-w-[800px] mx-auto px-6 md:px-12">
          <a href="/" className="font-wordmark text-c-cream text-lg hover:text-white transition-colors inline-block mb-16">
            chRsMa
          </a>
          <h1 className="text-4xl md:text-5xl font-light text-white mb-4">
            Terms of <span className="font-serif-italic text-gradient">Service</span>
          </h1>
          <p className="text-sm text-c-powder/50">Last updated: April 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="bg-c-cream py-20 md:py-32">
        <div className="max-w-[800px] mx-auto px-6 md:px-12">
          <div className="prose-chrsma">
            <h2>Agreement to Terms</h2>
            <p>
              By accessing or using chrsma.co, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use this site.
            </p>

            <h2>Services</h2>
            <p>
              CHRSMA provides strategic branding and positioning services. The scope, deliverables, and terms of any engagement are defined in individual agreements between CHRSMA and the client. This website serves as informational and does not constitute a binding offer.
            </p>

            <h2>Intellectual Property</h2>
            <p>
              All content on this site — including text, design, graphics, logos, and code — is the property of CHRSMA CO and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without written permission.
            </p>

            <h2>Client Work</h2>
            <p>
              Deliverables produced during an engagement become the client's property upon full payment, unless otherwise specified in the engagement agreement. CHRSMA retains the right to reference the engagement in portfolio materials unless a non-disclosure agreement is in place.
            </p>

            <h2>Limitation of Liability</h2>
            <p>
              CHRSMA provides strategic advisory and creative services. We are not liable for business outcomes resulting from the implementation of our recommendations. Our deliverables are strategic tools; their effectiveness depends on execution by the client's team.
            </p>

            <h2>Confidentiality</h2>
            <p>
              We treat all client information as confidential. Information shared during discovery, strategy sessions, and engagements will not be disclosed to third parties without written consent.
            </p>

            <h2>Modifications</h2>
            <p>
              We reserve the right to update these terms at any time. Changes will be reflected by the "Last updated" date above. Continued use of the site after changes constitutes acceptance.
            </p>

            <h2>Contact</h2>
            <p>
              For questions about these terms, contact us at <a href="mailto:hello@chrsma.co">hello@chrsma.co</a>.
            </p>
          </div>
        </div>
      </div>

      {/* Footer link */}
      <div className="bg-c-dark py-12">
        <div className="max-w-[800px] mx-auto px-6 md:px-12 flex justify-between items-center">
          <a href="/" className="text-xs text-c-powder/50 hover:text-c-cream transition-colors tracking-widest uppercase">&larr; Back to Home</a>
          <a href="/privacy" className="text-xs text-c-powder/50 hover:text-c-cream transition-colors tracking-widest uppercase">Privacy Policy</a>
        </div>
      </div>
    </div>
  );
};

export default Terms;
